export default {
  name: 'frodo',
  data(){
    return {
      rodoIsOn: true
    }
  },
  methods: {
    closeModal(){
      this.rodoIsOn = false;
      localStorage.setItem('rodo', true);
    }
  },
  mounted() {
    if(localStorage.rodo) {
      this.rodoIsOn = false;
    }
  }
}
